import React, { useState, useRef } from "react";
import { Formik } from "formik";
import { Alert } from "react-bootstrap";
import { onPreventEnterSubmitting } from "../../../utils/utils";
import { PageSubHeader } from "../../../../provider/PageDataProvider";
import { Toast } from "primereact/toast";

const AppForm = ({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  headSubmitButton = false,
}) => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const toastError = useRef(null);
  const [keyValue, setKeyValue] = useState([]);
  return (
    <>
      <Toast ref={toastError} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        dialogError={false}
        onSubmit={onSubmit}
        validateOnChange={false}
        onKeyDown={onPreventEnterSubmitting}
      >
        {({ values, handleSubmit, errors, dirty }) => (
          <form
            autoComplete="off"
            onSubmit={(e) => {
              handleSubmit(e);
              if (Object.keys(errors).length > 0) {
                toastError.current.show({
                  severity: "error",
                  summary: "Error Message",
                  life: 3000,
                  detail: (
                    <React.Fragment>
                      <div>
                        {Object.values(errors).map((error, index1) => (
                          <React.Fragment key={index1}>
                            {Array.isArray(error) ? (
                              (error.map((message, index2) => (
                                <React.Fragment key={index2}>
                                  {message !== undefined
                                    ? Object.keys(message).map(
                                        (key, index3) => {
                                          keyValue.push(key);
                                        }
                                      )
                                    : null}
                                </React.Fragment>
                              )),
                              [...new Set(keyValue)].map((key2, i) => (
                                <>
                                  {[
                                    ...new Set(error.map((item) => item[key2])),
                                  ]}
                                  <br />
                                </>
                              )))
                            ) : (
                              <>
                                {typeof error === "object" && error !== null ? (
                                  Object.values(error).map(
                                    (errorObject, index1) => (
                                      <>
                                        {errorObject} <br />
                                      </>
                                    )
                                  )
                                ) : (
                                  <>
                                    {error} <br />
                                  </>
                                )}
                              </>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </React.Fragment>
                  ),
                });
              }
            }}
          >
            {headSubmitButton ? (
              <PageSubHeader
                saveButton={{
                  showButton: true,
                  onClick: (e) => {
                    handleSubmit(e);
                    if (Object.keys(errors).length > 0) {
                      toastError.current.show({
                        severity: "error",
                        summary: "Error Message",
                        life: 3000,
                        detail: (
                          <React.Fragment>
                            <div>
                              {Object.values(errors).map((error, index1) => (
                                <React.Fragment key={index1}>
                                  {Array.isArray(error) ? (
                                    (error.map((message, index2) => (
                                      <React.Fragment key={index2}>
                                        {message !== undefined
                                          ? Object.keys(message).map(
                                              (key, index3) => {
                                                keyValue.push(key);
                                              }
                                            )
                                          : null}
                                      </React.Fragment>
                                    )),
                                    [...new Set(keyValue)].map((key2, i) => (
                                      <>
                                        {[
                                          ...new Set(
                                            error.map((item) => item[key2])
                                          ),
                                        ]}
                                        <br />
                                      </>
                                    )))
                                  ) : (
                                    <>
                                      {typeof error === "object" &&
                                      error !== null ? (
                                        Object.values(error).map(
                                          (errorObject, index1) => (
                                            <>
                                              {errorObject}
                                              <br />
                                            </>
                                          )
                                        )
                                      ) : (
                                        <>
                                          {error} <br />
                                        </>
                                      )}
                                    </>
                                  )}
                                </React.Fragment>
                              ))}
                            </div>
                          </React.Fragment>
                        ),
                      });
                    }
                  },
                }}
              />
            ) : null}
            {children}
          </form>
        )}
      </Formik>
    </>
  );
};

export default AppForm;
